
import React from 'react';
import { Loader2 } from 'lucide-react';
import SpotifyUrlInput from '../../upload/SpotifyUrlInput';
import FileUploader from '../../upload/FileUploader';
import TrackDetailsInput from '../../upload/TrackDetailsInput';

interface EditModeProps {
  spotifyUrl: string;
  isUrlValid: boolean;
  isSaving: boolean;
  currentFileName: string | null;
  trackTitle?: string;
  description?: string;
  onSpotifyUrlChange: (url: string) => void;
  onFileChange: (file: File | null) => void;
  onTitleChange: (title: string) => void;
  onDescriptionChange: (description: string) => void;
  onSaveEdit: () => Promise<void>;
  onCancelEdit: () => void;
  editFile: File | null;
}

const EditMode: React.FC<EditModeProps> = ({
  spotifyUrl,
  isUrlValid,
  isSaving,
  currentFileName,
  trackTitle = '',
  description = '',
  onSpotifyUrlChange,
  onFileChange,
  onTitleChange,
  onDescriptionChange,
  onSaveEdit,
  onCancelEdit,
  editFile
}) => {
  return (
    <div className="space-y-5">
      {isSaving && (
        <div className="flex items-center justify-center p-2 bg-secondary/50 rounded-md">
          <Loader2 size={16} className="mr-2 animate-spin" />
          <span className="text-sm">Saving changes...</span>
        </div>
      )}

      <div className="space-y-4">
        <div className="bg-background/80 p-3 rounded-md">
          <TrackDetailsInput
            title={trackTitle}
            description={description}
            onTitleChange={onTitleChange}
            onDescriptionChange={onDescriptionChange}
          />
        </div>
        
        <div className="bg-background/80 p-3 rounded-md">
          <SpotifyUrlInput 
            spotifyUrl={spotifyUrl}
            isUrlValid={isUrlValid}
            onChange={onSpotifyUrlChange}
          />
        </div>
        
        <div className="bg-background/80 p-3 rounded-md">
          <FileUploader 
            selectedFile={editFile}
            onChange={onFileChange}
            currentFileName={currentFileName}
          />
        </div>
      </div>
    </div>
  );
};

export default EditMode;
